import { CSSObject } from 'styled-components';

export const body1 = ({
    fontFamily: 'var(--plasma-typo-body1-font-family)',
    fontWeight: 'var(--plasma-typo-body1-font-weight)',
    fontStyle: 'var(--plasma-typo-body1-font-style)',
    fontSize: 'var(--plasma-typo-body1-font-size)',
    letterSpacing: 'var(--plasma-typo-body1-letter-spacing)',
    lineHeight: 'var(--plasma-typo-body1-line-height)',
} as unknown) as CSSObject;

export const body2 = ({
    fontFamily: 'var(--plasma-typo-body2-font-family)',
    fontWeight: 'var(--plasma-typo-body2-font-weight)',
    fontStyle: 'var(--plasma-typo-body2-font-style)',
    fontSize: 'var(--plasma-typo-body2-font-size)',
    letterSpacing: 'var(--plasma-typo-body2-letter-spacing)',
    lineHeight: 'var(--plasma-typo-body2-line-height)',
} as unknown) as CSSObject;

export const body3 = ({
    fontFamily: 'var(--plasma-typo-body3-font-family)',
    fontWeight: 'var(--plasma-typo-body3-font-weight)',
    fontStyle: 'var(--plasma-typo-body3-font-style)',
    fontSize: 'var(--plasma-typo-body3-font-size)',
    letterSpacing: 'var(--plasma-typo-body3-letter-spacing)',
    lineHeight: 'var(--plasma-typo-body3-line-height)',
} as unknown) as CSSObject;

export const button1 = ({
    fontFamily: 'var(--plasma-typo-button1-font-family)',
    fontWeight: 'var(--plasma-typo-button1-font-weight)',
    fontStyle: 'var(--plasma-typo-button1-font-style)',
    fontSize: 'var(--plasma-typo-button1-font-size)',
    letterSpacing: 'var(--plasma-typo-button1-letter-spacing)',
    lineHeight: 'var(--plasma-typo-button1-line-height)',
} as unknown) as CSSObject;

export const button2 = ({
    fontFamily: 'var(--plasma-typo-button2-font-family)',
    fontWeight: 'var(--plasma-typo-button2-font-weight)',
    fontStyle: 'var(--plasma-typo-button2-font-style)',
    fontSize: 'var(--plasma-typo-button2-font-size)',
    letterSpacing: 'var(--plasma-typo-button2-letter-spacing)',
    lineHeight: 'var(--plasma-typo-button2-line-height)',
} as unknown) as CSSObject;

export const caption = ({
    fontFamily: 'var(--plasma-typo-caption-font-family)',
    fontWeight: 'var(--plasma-typo-caption-font-weight)',
    fontStyle: 'var(--plasma-typo-caption-font-style)',
    fontSize: 'var(--plasma-typo-caption-font-size)',
    letterSpacing: 'var(--plasma-typo-caption-letter-spacing)',
    lineHeight: 'var(--plasma-typo-caption-line-height)',
} as unknown) as CSSObject;

export const display1 = ({
    fontFamily: 'var(--plasma-typo-display1-font-family)',
    fontWeight: 'var(--plasma-typo-display1-font-weight)',
    fontStyle: 'var(--plasma-typo-display1-font-style)',
    fontSize: 'var(--plasma-typo-display1-font-size)',
    letterSpacing: 'var(--plasma-typo-display1-letter-spacing)',
    lineHeight: 'var(--plasma-typo-display1-line-height)',
} as unknown) as CSSObject;

export const display2 = ({
    fontFamily: 'var(--plasma-typo-display2-font-family)',
    fontWeight: 'var(--plasma-typo-display2-font-weight)',
    fontStyle: 'var(--plasma-typo-display2-font-style)',
    fontSize: 'var(--plasma-typo-display2-font-size)',
    letterSpacing: 'var(--plasma-typo-display2-letter-spacing)',
    lineHeight: 'var(--plasma-typo-display2-line-height)',
} as unknown) as CSSObject;

export const display3 = ({
    fontFamily: 'var(--plasma-typo-display3-font-family)',
    fontWeight: 'var(--plasma-typo-display3-font-weight)',
    fontStyle: 'var(--plasma-typo-display3-font-style)',
    fontSize: 'var(--plasma-typo-display3-font-size)',
    letterSpacing: 'var(--plasma-typo-display3-letter-spacing)',
    lineHeight: 'var(--plasma-typo-display3-line-height)',
} as unknown) as CSSObject;

export const footnote1 = ({
    fontFamily: 'var(--plasma-typo-footnote1-font-family)',
    fontWeight: 'var(--plasma-typo-footnote1-font-weight)',
    fontStyle: 'var(--plasma-typo-footnote1-font-style)',
    fontSize: 'var(--plasma-typo-footnote1-font-size)',
    letterSpacing: 'var(--plasma-typo-footnote1-letter-spacing)',
    lineHeight: 'var(--plasma-typo-footnote1-line-height)',
} as unknown) as CSSObject;

export const footnote2 = ({
    fontFamily: 'var(--plasma-typo-footnote2-font-family)',
    fontWeight: 'var(--plasma-typo-footnote2-font-weight)',
    fontStyle: 'var(--plasma-typo-footnote2-font-style)',
    fontSize: 'var(--plasma-typo-footnote2-font-size)',
    letterSpacing: 'var(--plasma-typo-footnote2-letter-spacing)',
    lineHeight: 'var(--plasma-typo-footnote2-line-height)',
} as unknown) as CSSObject;

export const headline1 = ({
    fontFamily: 'var(--plasma-typo-headline1-font-family)',
    fontWeight: 'var(--plasma-typo-headline1-font-weight)',
    fontStyle: 'var(--plasma-typo-headline1-font-style)',
    fontSize: 'var(--plasma-typo-headline1-font-size)',
    letterSpacing: 'var(--plasma-typo-headline1-letter-spacing)',
    lineHeight: 'var(--plasma-typo-headline1-line-height)',
} as unknown) as CSSObject;

export const headline2 = ({
    fontFamily: 'var(--plasma-typo-headline2-font-family)',
    fontWeight: 'var(--plasma-typo-headline2-font-weight)',
    fontStyle: 'var(--plasma-typo-headline2-font-style)',
    fontSize: 'var(--plasma-typo-headline2-font-size)',
    letterSpacing: 'var(--plasma-typo-headline2-letter-spacing)',
    lineHeight: 'var(--plasma-typo-headline2-line-height)',
} as unknown) as CSSObject;

export const headline3 = ({
    fontFamily: 'var(--plasma-typo-headline3-font-family)',
    fontWeight: 'var(--plasma-typo-headline3-font-weight)',
    fontStyle: 'var(--plasma-typo-headline3-font-style)',
    fontSize: 'var(--plasma-typo-headline3-font-size)',
    letterSpacing: 'var(--plasma-typo-headline3-letter-spacing)',
    lineHeight: 'var(--plasma-typo-headline3-line-height)',
} as unknown) as CSSObject;

export const headline4 = ({
    fontFamily: 'var(--plasma-typo-headline4-font-family)',
    fontWeight: 'var(--plasma-typo-headline4-font-weight)',
    fontStyle: 'var(--plasma-typo-headline4-font-style)',
    fontSize: 'var(--plasma-typo-headline4-font-size)',
    letterSpacing: 'var(--plasma-typo-headline4-letter-spacing)',
    lineHeight: 'var(--plasma-typo-headline4-line-height)',
} as unknown) as CSSObject;

export const paragraph1 = ({
    fontFamily: 'var(--plasma-typo-paragraph1-font-family)',
    fontWeight: 'var(--plasma-typo-paragraph1-font-weight)',
    fontStyle: 'var(--plasma-typo-paragraph1-font-style)',
    fontSize: 'var(--plasma-typo-paragraph1-font-size)',
    letterSpacing: 'var(--plasma-typo-paragraph1-letter-spacing)',
    lineHeight: 'var(--plasma-typo-paragraph1-line-height)',
} as unknown) as CSSObject;

export const paragraph2 = ({
    fontFamily: 'var(--plasma-typo-paragraph2-font-family)',
    fontWeight: 'var(--plasma-typo-paragraph2-font-weight)',
    fontStyle: 'var(--plasma-typo-paragraph2-font-style)',
    fontSize: 'var(--plasma-typo-paragraph2-font-size)',
    letterSpacing: 'var(--plasma-typo-paragraph2-letter-spacing)',
    lineHeight: 'var(--plasma-typo-paragraph2-line-height)',
} as unknown) as CSSObject;

export const underline = ({
    fontFamily: 'var(--plasma-typo-underline-font-family)',
    fontWeight: 'var(--plasma-typo-underline-font-weight)',
    fontStyle: 'var(--plasma-typo-underline-font-style)',
    fontSize: 'var(--plasma-typo-underline-font-size)',
    letterSpacing: 'var(--plasma-typo-underline-letter-spacing)',
    lineHeight: 'var(--plasma-typo-underline-line-height)',
} as unknown) as CSSObject;
